module.exports = __webpack_public_path__ + "img/pin2.ced9ec6c.svg";